import React from 'react'

const TitleView = ({ text }) => {
  return <div className='title_view'>{text}</div>;
};

export default TitleView;